import { StepType } from '@reactour/tour';
import { Text } from '@/components/ui/base/Text';
import { Column } from '@/components/ui/layout/Column';
import { Row } from '@/components/ui/layout/Row';
import { Button } from '@/components/ui/Button';

export const filesSteps: StepType[] = [
  {
    selector: 'none',
    content: (props) => (
      <Column>
        <Text weight="semibold">Bienvenue dans le tutoriel !</Text>
        <Text size="sm">
          👉 Vous pouvez naviguer entre les étapes en utilisant les flèches de
          votre clavier, ou bien en cliquant sur la zone grisée de l'écran.
        </Text>
        <Row>
          <Text size="sm">
            👉 Vous pouvez fermer le tutoriel en cliquant sur la croix en haut à
            droite de l'écran.
          </Text>
        </Row>
        <Button
          className="my-1"
          onClick={() => {
            props.setCurrentStep(1);
          }}
        >
          Commencer
        </Button>
      </Column>
    ),
    position: 'center',
    styles: {
      maskArea: () => ({
        display: 'none',
      }),
      controls: () => ({
        display: 'none',
      }),
    },
  },
  {
    selector: '.file-list-table',
    content: (props) => (
      <Column>
        <Text>
          Voici votre tableau de fichiers. Vous pouvez voir tous vos documents
          ici.
        </Text>
        <Button
          onClick={() => {
            props.setCurrentStep(2);
          }}
        >
          Suivant
        </Button>
      </Column>
    ),
    position: 'bottom',
    highlightedSelectors: ['.file-list-table'],
    stepInteraction: false,
  },
  {
    selector: '.file-list-filters',
    content: () => (
      <Column>
        <Text>
          Vous pouvez utiliser ces filtres pour trier et filtrer vos fichiers
          selon différents critères.
        </Text>
        <Row>
          <Text>
            👉 Essayez d'appuyer sur le bouton "Filtrer" pour ouvrir le panneau
            des filtres avancés.
          </Text>
        </Row>
      </Column>
    ),
    position: 'bottom',
    highlightedSelectors: ['.file-list-filters'],
    resizeObservables: ['.file-list-filters'],
    styles: {
      arrow: () => ({
        display: 'none',
      }),
    },
  },
  {
    selector: '.file-list-filters-modal',
    content: () => (
      <Column>
        <Text>
          Voici le panneau des filtres avancés. Vous pouvez utiliser ces filtres
          pour trier et filtrer vos fichiers selon différents critères, et les
          réinitialiser en appuyant sur la flèche en haut à droite du panneau.
        </Text>
        <Row>
          <Text>
            👉 Pour passer à l'étape suivante, essayez de trier par fichiers
            favoris uniquement.
          </Text>
        </Row>
      </Column>
    ),
    position: 'bottom',
    resizeObservables: ['.file-list-filters-modal'],
    highlightedSelectors: ['.file-list-filters-modal'],
    styles: {
      arrow: () => ({
        display: 'none',
      }),
    },
  },
  {
    selector: '.file-list-search',
    content: () => (
      <Column>
        <Text>
          La barre de recherche vous permet de trouver rapidement un fichier
          spécifique.
        </Text>
        <Row>
          <Text>👉 Cherchez le document "remb_sante".</Text>
        </Row>
      </Column>
    ),
    position: 'bottom',
    resizeObservables: ['.file-list-search'],
  },
  {
    selector: '.file-list-download',
    content: () => (
      <Column>
        <Text>
          👉 Appuyez sur ce bouton pour télécharger la liste de tous les
          fichiers
        </Text>
      </Column>
    ),
    position: 'bottom',
  },
  {
    selector: '.file-list-row',
    content: () => (
      <Column>
        <Text>
          La liste des documents a bien été téléchargée ! Vous pouvez la
          consulter dans votre dossier téléchargements.
        </Text>
        <Row>
          <Text>
            👉 Passons maintenant à la partie analyse en cliquant sur ce
            fichier.
          </Text>
        </Row>
      </Column>
    ),
    position: 'right',
  },
];
